/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */
import { jwtDecode } from 'jwt-decode';
import config from './config';
import { dcfformname, ucfformname, ocfformname, cscfformname } from './consts';

const HOST = config.apiGateway.URL;
const ENDPOINT = 'dcfservice/submit';
const APIURL = HOST + ENDPOINT;
const IRTURL = 'Not implemented';

export const convertFormForApi = (data) => {
  const form = {
    dcfFormType: data.form,
    ticketPriority: data.priority,
    additionalContactsOrEmails: (data.additional || '').replaceAll('\n', ','),
    siteId: data.site,
    subjectId: data.subject,
    reasonForChange: data.reason,
    changeText: data.change
  };
  if (data.form && data.form !== 'UCF') {
    form.patientAtSite = data.patient;
  } else {
    if (data.userChangeType === 'Single user') {
      form.userType = data.userType;
      form.userRole = data.userRole;
    }
    form.userChangeType = data.userChangeType;
    delete form.siteId;
    delete form.subjectId;
  }
  return form;
};

export const postData = async (token, form, files) => {
  let payload;
  try {
    payload = jwtDecode(token);
  } catch {
    return false;
  }
  if (!payload) return false;
  const {
    studyId,
    clientName,
    studyName,
    requestorName,
    requestorEmail,
    requestorLocation,
    requestorStudyBlindingStatus,
    projectName,
    localDateTime,
    serverDateTime
  } = payload;
  let autoroute, requiresApproval;
  if (payload.ocfFieldsData && form.form === ocfformname) {
    autoroute = payload.ocfFieldsData.ocfRoutingJiraWorkflow;
    requiresApproval = payload.ocfFieldsData.ocfRequiresApproval;
  } else if (payload.cscfFieldsData && form.form === cscfformname) {
    autoroute = payload.cscfFieldsData.cscfRoutingJiraWorkflow;
    requiresApproval = payload.cscfFieldsData.cscfRequiresApproval;
  } else if (payload.ucfFieldsData && form.form === ucfformname) {
    autoroute = payload.ucfFieldsData.ucfRoutingJiraWorkflow;
    requiresApproval = payload.ucfFieldsData.ucfRequiresApproval;
  } else if (payload.dcfFieldsData && form.form === dcfformname) {
    autoroute = payload.dcfFieldsData.dcfRoutingJiraWorkflow;
    requiresApproval = payload.dcfFieldsData.dcfRequiresApproval;
  }
  const formData = new FormData();
  formData.append(
    'form',
    JSON.stringify({
      ...convertFormForApi(form),
      studyId,
      clientName,
      studyName,
      requestorName,
      requestorEmail,
      requestorLocation,
      requestorStudyBlindingStatus,
      autoroute,
      projectName,
      requiresApproval,
      localDateTime,
      serverDateTime
    })
  );
  files.forEach((f) => formData.append('files', f));
  try {
    const response = await fetch(APIURL, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });
    if (response && response.ok) return response.json();
    return false;
  } catch (err) {
    console.log('FETCH FAILED', err);
    return false;
  }
};

export const verifyPassword = async (password) => {
  if (!password || password.length === 0) return false;
  if (IRTURL === 'Not implemented') {
    return new Promise((resolve) => {
      setTimeout(() => resolve(password === 'correct'), 2000);
    });
  }
  try {
    return await fetch(IRTURL);
  } catch (e) {
    console.log('Password validation failed:', e);
    return false;
  }
};

export const fetchStudyFormMessage = () => {};
